import _ from 'lodash';
import { t } from 'utils/localize';

export default function v_does_not_contain(value: any, args: { inValues: any[]; message?: string }) {
  return {
    message: args.message || t('Invalid value'),
    validate: () => !args.inValues.some((val) => _.isEqual(value, val)),
  };
}
